import React from "react";
import { COLORS } from "../utils/colors";

export const OpenInNewTab = () => (
  <svg
    width="15"
    stroke={COLORS.darkGray}
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 8.625V12.375C11.25 12.7065 11.1183 13.0245 10.8839 13.2589C10.6495 13.4933 10.3315 13.625 10 13.625H3.125C2.79348 13.625 2.47554 13.4933 2.24112 13.2589C2.0067 13.0245 1.875 12.7065 1.875 12.375V5.5C1.875 5.16848 2.0067 4.85054 2.24112 4.61612C2.47554 4.3817 2.79348 4.25 3.125 4.25H6.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.375 2.375H13.125V6.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 9.25L13.125 2.375"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6721 4.69385L4.17212 12.1938"
      stroke="#8D8D8D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.17212 4.69385L11.6721 12.1938"
      stroke="#8D8D8D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SlackIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_481:6312)">
      <path
        d="M3.12295 9.49183C3.12295 10.3648 2.40984 11.0779 1.53689 11.0779C0.663936 11.0779 -0.0491791 10.3648 -0.0491791 9.49183C-0.0491791 8.61888 0.663936 7.90576 1.53689 7.90576H3.12295V9.49183Z"
        fill="#E01E5A"
      />
      <path
        d="M3.92213 9.49183C3.92213 8.61888 4.63525 7.90576 5.5082 7.90576C6.38115 7.90576 7.09426 8.61888 7.09426 9.49183V13.4631C7.09426 14.3361 6.38115 15.0492 5.5082 15.0492C4.63525 15.0492 3.92213 14.3361 3.92213 13.4631V9.49183Z"
        fill="#E01E5A"
      />
      <path
        d="M5.5082 3.12294C4.63525 3.12294 3.92213 2.40982 3.92213 1.53687C3.92213 0.663921 4.63525 -0.0491943 5.5082 -0.0491943C6.38115 -0.0491943 7.09426 0.663921 7.09426 1.53687V3.12294H5.5082Z"
        fill="#36C5F0"
      />
      <path
        d="M5.5082 3.92206C6.38115 3.92206 7.09426 4.63517 7.09426 5.50812C7.09426 6.38108 6.38115 7.09419 5.5082 7.09419H1.53689C0.663936 7.09419 -0.0491791 6.38108 -0.0491791 5.50812C-0.0491791 4.63517 0.663936 3.92206 1.53689 3.92206H5.5082Z"
        fill="#36C5F0"
      />
      <path
        d="M11.8771 5.50812C11.8771 4.63517 12.5902 3.92206 13.4631 3.92206C14.3361 3.92206 15.0492 4.63517 15.0492 5.50812C15.0492 6.38108 14.3361 7.09419 13.4631 7.09419H11.8771V5.50812Z"
        fill="#2EB67D"
      />
      <path
        d="M11.0779 5.50818C11.0779 6.38113 10.3648 7.09425 9.4918 7.09425C8.61885 7.09425 7.90574 6.38113 7.90574 5.50818V1.53687C7.90574 0.663921 8.61885 -0.0491943 9.4918 -0.0491943C10.3648 -0.0491943 11.0779 0.663921 11.0779 1.53687V5.50818Z"
        fill="#2EB67D"
      />
      <path
        d="M9.4918 11.8771C10.3648 11.8771 11.0779 12.5902 11.0779 13.4631C11.0779 14.3361 10.3648 15.0492 9.4918 15.0492C8.61885 15.0492 7.90574 14.3361 7.90574 13.4631V11.8771H9.4918Z"
        fill="#ECB22E"
      />
      <path
        d="M9.4918 11.0779C8.61885 11.0779 7.90574 10.3648 7.90574 9.49183C7.90574 8.61888 8.61885 7.90576 9.4918 7.90576H13.4631C14.3361 7.90576 15.0492 8.61888 15.0492 9.49183C15.0492 10.3648 14.3361 11.0779 13.4631 11.0779H9.4918Z"
        fill="#ECB22E"
      />
    </g>
    <defs>
      <clipPath id="clip0_481:6312">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HttpBinIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_521_6326)">
      <path
        d="M2 4.5H3.25H13.25"
        stroke="#F7F7F8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.92857 4.6V3.3C4.92857 2.95522 5.06403 2.62456 5.30515 2.38076C5.54627 2.13696 5.87329 2 6.21429 2H8.78571C9.12671 2 9.45373 2.13696 9.69485 2.38076C9.93597 2.62456 10.0714 2.95522 10.0714 3.3V4.6M12 4.6V13.7C12 14.0448 11.8645 14.3754 11.6234 14.6192C11.3823 14.863 11.0553 15 10.7143 15H4.28571C3.94472 15 3.6177 14.863 3.37658 14.6192C3.13546 14.3754 3 14.0448 3 13.7V4.6H12Z"
        stroke="#F7F7F8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.88867 6.64648C6.08236 6.42188 6.32731 6.30957 6.62354 6.30957C7.18669 6.30957 7.47233 6.63102 7.48047 7.27393V9H6.88721V7.2959C6.88721 7.11361 6.84733 6.98503 6.76758 6.91016C6.68945 6.83366 6.57389 6.79541 6.4209 6.79541C6.18327 6.79541 6.00586 6.9012 5.88867 7.11279V9H5.29541V5.25H5.88867V6.64648ZM9.12568 5.71631V6.3584H9.59199V6.79785H9.12568V8.27246C9.12568 8.37337 9.14521 8.44661 9.18428 8.49219C9.22497 8.53613 9.29658 8.55811 9.39912 8.55811C9.46748 8.55811 9.53665 8.54997 9.60664 8.53369V8.99268C9.47155 9.03011 9.34134 9.04883 9.21602 9.04883C8.76029 9.04883 8.53242 8.79736 8.53242 8.29443V6.79785H8.09785V6.3584H8.53242V5.71631H9.12568ZM6.04736 9.71631V10.3584H6.51367V10.7979H6.04736V12.2725C6.04736 12.3734 6.06689 12.4466 6.10596 12.4922C6.14665 12.5361 6.21826 12.5581 6.3208 12.5581C6.38916 12.5581 6.45833 12.55 6.52832 12.5337V12.9927C6.39323 13.0301 6.26302 13.0488 6.1377 13.0488C5.68197 13.0488 5.4541 12.7974 5.4541 12.2944V10.7979H5.01953V10.3584H5.4541V9.71631H6.04736ZM9.58223 11.7061C9.58223 12.1146 9.48945 12.4409 9.30391 12.6851C9.11836 12.9276 8.86934 13.0488 8.55684 13.0488C8.26712 13.0488 8.03519 12.9536 7.86104 12.7632V14.0156H7.26777V10.3584H7.81465L7.83906 10.627C8.01322 10.4154 8.25003 10.3096 8.54951 10.3096C8.87178 10.3096 9.12406 10.43 9.30635 10.6709C9.49027 10.9102 9.58223 11.243 9.58223 11.6694V11.7061ZM8.99141 11.6548C8.99141 11.3911 8.93851 11.182 8.83271 11.0273C8.72855 10.8727 8.57881 10.7954 8.3835 10.7954C8.14098 10.7954 7.96683 10.8955 7.86104 11.0957V12.2676C7.96846 12.4727 8.14424 12.5752 8.38838 12.5752C8.57718 12.5752 8.72448 12.4995 8.83027 12.3481C8.9377 12.1951 8.99141 11.964 8.99141 11.6548Z"
        fill="#F7F7F8"
      />
    </g>
    <defs>
      <clipPath id="clip0_521_6326">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0.192871 0.885254)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const StripeIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.47801 4.46703C6.47801 3.82418 7.00548 3.57692 7.87911 3.57692C9.13185 3.57692 10.7143 3.95604 11.967 4.63187V0.758242C10.5989 0.214285 9.24724 0 7.87911 0C4.53295 0 2.30768 1.74725 2.30768 4.66484C2.30768 9.21429 8.57141 8.48901 8.57141 10.4506C8.57141 11.2088 7.91207 11.456 6.989 11.456C5.62087 11.456 3.87361 10.8956 2.489 10.1374V14.0604C4.02196 14.7198 5.57141 15 6.989 15C10.4176 15 12.7747 13.3022 12.7747 10.3516C12.7582 5.43956 6.47801 6.31319 6.47801 4.46703Z"
      fill="#635BFF"
    />
  </svg>
);

export const APIsIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.8769 7.8462H10.3575C10.5245 8.94697 11.4699 9.79384 12.6111 9.79384C13.8696 9.79384 14.8935 8.76489 14.8935 7.50005C14.8935 6.2352 13.8696 5.20626 12.611 5.20626C11.4699 5.20626 10.5244 6.05312 10.3573 7.15389H5.86426C5.82463 6.8633 5.74276 6.58014 5.61919 6.31395L9.89107 3.83376C10.3205 4.37099 10.9761 4.69412 11.6732 4.69412C12.072 4.69412 12.4661 4.58768 12.813 4.38622C13.9018 3.75397 14.2761 2.34893 13.6477 1.25422C13.2413 0.546163 12.4829 0.106201 11.6686 0.106201C11.2696 0.106201 10.8755 0.212643 10.5287 0.414105C9.54094 0.987509 9.14372 2.1961 9.54717 3.23301L5.25434 5.72532C5.03644 5.45203 4.76799 5.21266 4.44849 5.0273C4.00871 4.77184 3.50886 4.63684 3.0033 4.63684C1.97072 4.63684 1.00911 5.19466 0.493513 6.09276C-0.303852 7.48135 0.171071 9.26353 1.55205 10.0656C1.99201 10.321 2.49169 10.456 2.99724 10.456C3.90728 10.456 4.76211 10.0221 5.30523 9.30437L9.54717 11.7671C9.1439 12.804 9.54094 14.0126 10.5287 14.586C10.8755 14.7875 11.2696 14.8939 11.6684 14.8939C11.6686 14.8939 11.6686 14.8939 11.6686 14.8939C12.4827 14.8939 13.2413 14.4539 13.6479 13.7457C14.2765 12.6508 13.902 11.246 12.8131 10.6137C12.4663 10.4122 12.072 10.3058 11.6732 10.3058C10.9761 10.3058 10.3206 10.6291 9.89107 11.1662L5.65328 8.70587C5.77426 8.42722 5.84713 8.13749 5.8769 7.8462ZM12.611 5.89857C13.4876 5.89857 14.201 6.61701 14.201 7.50005C14.201 8.38309 13.4878 9.10153 12.611 9.10153C11.7342 9.10153 11.0207 8.38309 11.0207 7.50005C11.0207 6.61701 11.7342 5.89857 12.611 5.89857ZM10.8762 1.01278C11.1178 0.872586 11.3918 0.798509 11.6686 0.798509C12.2356 0.798509 12.764 1.1052 13.0475 1.59899C13.4867 2.36434 13.2257 3.3462 12.4656 3.78772C12.224 3.92791 11.95 4.00199 11.6734 4.00199C11.1062 4.00199 10.5778 3.6953 10.2943 3.20151C9.8549 2.43599 10.1157 1.4543 10.8762 1.01278ZM4.90698 8.65534C4.51444 9.33899 3.78284 9.76372 2.99742 9.76372C2.61388 9.76372 2.23432 9.66109 1.89976 9.46689C0.847283 8.85576 0.485898 7.49676 1.09409 6.43753C1.48663 5.75387 2.21823 5.32914 3.00348 5.32914C3.38701 5.32914 3.76657 5.43178 4.10113 5.62597C5.15361 6.23693 5.51499 7.59593 4.90698 8.65534ZM11.6731 10.9981C11.95 10.9981 12.224 11.0722 12.4654 11.2124C13.2257 11.6537 13.4866 12.6356 13.0473 13.4011C12.7638 13.8949 12.2356 14.2016 11.6684 14.2016C11.3915 14.2016 11.1175 14.1275 10.8761 13.9873C10.1157 13.5458 9.85472 12.5639 10.2942 11.7986C10.5777 11.305 11.1061 10.9981 11.6731 10.9981Z"
      fill="#F7F7F8"
    />
  </svg>
);

export const GithubIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.50006 0C3.35843 0 0 3.4384 0 7.68006C0 11.0733 2.149 13.9521 5.129 14.9677C5.50383 15.0387 5.64144 14.801 5.64144 14.5982C5.64144 14.4151 5.63449 13.8101 5.63126 13.1683C3.54473 13.6329 3.10445 12.2622 3.10445 12.2622C2.76328 11.3745 2.2717 11.1384 2.2717 11.1384C1.59122 10.6618 2.323 10.6716 2.323 10.6716C3.07613 10.7257 3.4727 11.463 3.4727 11.463C4.14163 12.6371 5.22724 12.2977 5.65523 12.1014C5.72254 11.6051 5.91691 11.2662 6.1314 11.0745C4.46554 10.8803 2.71434 10.2217 2.71434 7.27894C2.71434 6.44045 3.00733 5.75534 3.4871 5.2175C3.40923 5.02406 3.15251 4.24293 3.55976 3.18506C3.55976 3.18506 4.18957 2.97865 5.62281 3.9723C6.22107 3.80213 6.86268 3.7168 7.50006 3.71387C8.13745 3.7168 8.77955 3.80213 9.37893 3.9723C10.8104 2.97865 11.4394 3.18506 11.4394 3.18506C11.8476 4.24293 11.5908 5.02406 11.5129 5.2175C11.9938 5.75534 12.2848 6.44045 12.2848 7.27894C12.2848 10.2287 10.5302 10.8782 8.86015 11.0684C9.12917 11.3067 9.36887 11.7741 9.36887 12.4906C9.36887 13.5182 9.36017 14.3452 9.36017 14.5982C9.36017 14.8026 9.49518 15.0421 9.87535 14.9666C12.8537 13.95 15 11.0722 15 7.68006C15 3.4384 11.6421 0 7.50006 0ZM2.80902 10.9404C2.7925 10.9786 2.73388 10.99 2.68047 10.9638C2.62607 10.9388 2.59552 10.8867 2.61316 10.8485C2.6293 10.8092 2.68805 10.7982 2.74232 10.8246C2.79685 10.8496 2.8279 10.9021 2.80902 10.9404ZM3.17794 11.2775C3.14217 11.3115 3.07224 11.2957 3.0248 11.242C2.97574 11.1885 2.96655 11.1169 3.00282 11.0824C3.0397 11.0484 3.10752 11.0643 3.1567 11.1179C3.20576 11.1721 3.21532 11.2432 3.17794 11.2775ZM3.43103 11.7088C3.38508 11.7415 3.30994 11.7108 3.26349 11.6425C3.21753 11.5742 3.21753 11.4923 3.26448 11.4595C3.31105 11.4267 3.38508 11.4562 3.43215 11.524C3.47798 11.5934 3.47798 11.6753 3.43103 11.7088ZM3.85906 12.2083C3.81795 12.2547 3.73039 12.2422 3.66631 12.1789C3.60073 12.117 3.58248 12.0291 3.62371 11.9827C3.66532 11.9361 3.75337 11.9492 3.81795 12.012C3.88303 12.0738 3.90291 12.1624 3.85906 12.2083ZM4.41226 12.3769C4.39412 12.437 4.30979 12.4644 4.22484 12.4388C4.14002 12.4125 4.0845 12.342 4.10164 12.2813C4.11927 12.2207 4.20398 12.1922 4.28955 12.2196C4.37425 12.2458 4.42989 12.3157 4.41226 12.3769ZM5.04181 12.4484C5.04392 12.5118 4.97189 12.5643 4.88272 12.5654C4.79304 12.5675 4.72051 12.5162 4.71952 12.4539C4.71952 12.3899 4.78994 12.3379 4.87961 12.3364C4.96879 12.3346 5.04181 12.3855 5.04181 12.4484ZM5.66028 12.4241C5.67096 12.4859 5.60899 12.5494 5.52044 12.5663C5.43337 12.5826 5.35277 12.5445 5.34171 12.4832C5.33091 12.4198 5.394 12.3564 5.48094 12.3399C5.56962 12.3242 5.64898 12.3613 5.66028 12.4241Z"
      fill="#F7F7F8"
    />
  </svg>
);

export const PetstoreIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_483:6336)">
      <path
        d="M13.0421 11.7158L12.9947 11.5579L12.9 11.3053L12.8368 11.1474L12.6632 10.8316L12.4263 10.5316L12.1105 10.2474L11.7474 9.91578L11.4474 9.63157L11.1632 9.31578L10.9263 8.99999L10.7053 8.66841L10.4684 8.22631L10.3263 7.92631L10.1526 7.59473L9.93157 7.23157L9.67894 6.89999L9.50526 6.72631L9.33157 6.56841L9.09473 6.39473L8.81052 6.26841L8.44736 6.1421L8.0842 6.09473H7.70526L7.3421 6.1421L6.82105 6.33157L6.31578 6.67894L5.9842 7.01052L5.77894 7.32631L5.57368 7.68946L5.30526 8.2421L5.05263 8.73157L4.76841 9.11052L4.42105 9.55262L3.39473 10.5L3.29999 10.5789L3.06315 10.9105L2.87368 11.2895L2.76315 11.7631L2.69999 12.1895L2.6842 12.6631L2.73157 12.9789L2.87368 13.421L3.07894 13.8316L3.29999 14.1158L3.5842 14.4L3.96315 14.6526L4.40526 14.8579L4.73684 14.9368L5.2421 14.9526L5.73157 14.8421L6.03157 14.7L6.15789 14.6053L6.4421 14.4474L6.71052 14.2895L6.94736 14.1474L7.19999 14.0368L7.40526 13.9421L7.6421 13.8789L7.89473 13.8631L8.19473 13.9105L8.41578 13.9579L8.77894 14.1316L9.22105 14.3526L9.5842 14.5895L9.91578 14.7789L10.2474 14.921L10.5632 14.9842L10.8316 15L11.0526 14.9842L11.4 14.8895L11.8421 14.6842L12.1579 14.4631L12.4895 14.1316L12.7263 13.8158L12.9316 13.3895L13.0579 12.9789L13.1053 12.6316V12.2684L13.0895 12.0631L13.0421 11.7158Z"
        fill="#F7F7F8"
      />
      <path
        d="M11.7808 3.392C11.9221 2.05646 11.2774 0.893474 10.3408 0.794398C9.40415 0.695322 8.53035 1.69767 8.38907 3.03321C8.2478 4.36875 8.89254 5.53173 9.82916 5.63081C10.7658 5.72989 11.6396 4.72754 11.7808 3.392Z"
        fill="#F7F7F8"
      />
      <path
        d="M5.95587 5.6243C6.89248 5.52523 7.53723 4.36224 7.39596 3.0267C7.25468 1.69117 6.38088 0.688815 5.44427 0.787891C4.50766 0.886968 3.86291 2.04995 4.00418 3.38549C4.14546 4.72103 5.01926 5.72338 5.95587 5.6243Z"
        fill="#F7F7F8"
      />
      <path
        d="M14.9103 7.35032C15.2003 6.048 14.6903 4.82629 13.771 4.62154C12.8517 4.4168 11.8713 5.30655 11.5813 6.60887C11.2912 7.91118 11.8013 9.1329 12.7206 9.33764C13.6399 9.54239 14.6202 8.65263 14.9103 7.35032Z"
        fill="#F7F7F8"
      />
      <path
        d="M3.06708 9.3372C3.98636 9.13245 4.49645 7.91074 4.20639 6.60842C3.91634 5.30611 2.93598 4.41635 2.0167 4.6211C1.09741 4.82584 0.587325 6.04756 0.877381 7.34987C1.16744 8.65219 2.1478 9.54195 3.06708 9.3372Z"
        fill="#F7F7F8"
      />
    </g>
    <defs>
      <clipPath id="clip0_483:6336">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SearchIcon = ({ color }: { color?: string }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.97966 10.759C8.74109 10.759 10.9797 8.5204 10.9797 5.75897C10.9797 2.99755 8.74109 0.758972 5.97966 0.758972C3.21824 0.758972 0.979664 2.99755 0.979664 5.75897C0.979664 8.5204 3.21824 10.759 5.97966 10.759Z"
      stroke={color || "#8D8D8D"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7892 12.7065L9.66425 9.58148"
      stroke={color || "#8D8D8D"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrow = () => {
  return (
    <>
      <svg
        className="normal"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.625 11.25L9.375 7.5L5.625 3.75"
          stroke="#8D8D8D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <svg
        className="onhover"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.625 11.25L9.375 7.5L5.625 3.75"
          stroke={COLORS.onHoverPurple}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const WhiteGoArrow = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.68054 8.27777H12.4305"
        stroke="#F7F7F8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.05554 3.90277L12.4305 8.27777L8.05554 12.6528"
        stroke="#F7F7F8"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Book = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 1.875H5C5.66304 1.875 6.29893 2.13839 6.76777 2.60723C7.23661 3.07607 7.5 3.71196 7.5 4.375V13.125C7.5 12.6277 7.30246 12.1508 6.95083 11.7992C6.59919 11.4475 6.12228 11.25 5.625 11.25H1.25V1.875Z"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 1.875H10C9.33696 1.875 8.70107 2.13839 8.23223 2.60723C7.76339 3.07607 7.5 3.71196 7.5 4.375V13.125C7.5 12.6277 7.69754 12.1508 8.04917 11.7992C8.40081 11.4475 8.87772 11.25 9.375 11.25H13.75V1.875Z"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const List = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 3.75H13.125"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.5H13.125"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 11.25H13.125"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.875 3.75H1.88125"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.875 7.5H1.88125"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.875 11.25H1.88125"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Protection = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 13.5C6 13.5 11 11 11 7.25V2.875L6 1L1 2.875V7.25C1 11 6 13.5 6 13.5Z"
      stroke="#718FE8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Lock = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_514_6312)">
      <path
        d="M12.5425 7.03113H3.79248C3.10212 7.03113 2.54248 7.59077 2.54248 8.28113V12.6561C2.54248 13.3465 3.10212 13.9061 3.79248 13.9061H12.5425C13.2328 13.9061 13.7925 13.3465 13.7925 12.6561V8.28113C13.7925 7.59077 13.2328 7.03113 12.5425 7.03113Z"
        stroke="#8D8D8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.04248 7.03113V4.53113C5.04248 3.70233 5.37172 2.90747 5.95777 2.32142C6.54382 1.73537 7.33868 1.40613 8.16748 1.40613C8.99628 1.40613 9.79114 1.73537 10.3772 2.32142C10.9632 2.90747 11.2925 3.70233 11.2925 4.53113V7.03113"
        stroke="#8D8D8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_514_6312">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0.66748 0.156128)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BigWhiteBook = () => (
  <svg
    style={{ marginRight: 12 }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
      stroke="#F7F7F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
      stroke="#F7F7F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BigWhiteLightning = () => (
  <svg
    style={{ marginRight: 12 }}
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.469 2.20599L3.46899 14.206H12.469L11.469 22.206L21.469 10.206H12.469L13.469 2.20599Z"
      stroke="#F7F7F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BigWhiteLock = () => (
  <svg
    style={{ marginRight: 12 }}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 11H5C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V13C21 11.8954 20.1046 11 19 11Z"
      stroke="#F7F7F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V11"
      stroke="#F7F7F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoogleCalendar = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.4473 3.55261H3.55261V11.4473H11.4473V3.55261Z" fill="white" />
    <path d="M11.4474 15L15 11.4474H11.4474V15Z" fill="#EA4335" />
    <path d="M15 3.55261H11.4474V11.4473H15V3.55261Z" fill="#FBBC04" />
    <path d="M11.4473 11.4474H3.55261V15H11.4473V11.4474Z" fill="#34A853" />
    <path
      d="M0 11.4474V13.8158C0 14.4701 0.529934 15 1.18421 15H3.55263V11.4474H0Z"
      fill="#188038"
    />
    <path
      d="M15 3.55263V1.18421C15 0.529934 14.4701 0 13.8158 0H11.4474V3.55263H15Z"
      fill="#1967D2"
    />
    <path
      d="M11.4474 0H1.18421C0.529934 0 0 0.529934 0 1.18421V11.4474H3.55263V3.55263H11.4474V0Z"
      fill="#4285F4"
    />
    <path
      d="M5.17207 9.67706C4.87701 9.47772 4.67273 9.1866 4.56122 8.80174L5.24609 8.5195C5.30826 8.75634 5.41681 8.93989 5.57174 9.07016C5.72569 9.20042 5.91319 9.26456 6.13227 9.26456C6.35629 9.26456 6.54872 9.19647 6.70957 9.06029C6.87043 8.9241 6.95135 8.75042 6.95135 8.54022C6.95135 8.32509 6.86648 8.14943 6.69674 8.01325C6.52701 7.87706 6.31385 7.80897 6.05924 7.80897H5.66352V7.13101H6.01878C6.23786 7.13101 6.4224 7.0718 6.5724 6.95338C6.7224 6.83496 6.7974 6.67312 6.7974 6.46687C6.7974 6.28331 6.7303 6.13726 6.59609 6.02772C6.46188 5.91818 6.29214 5.86292 6.08589 5.86292C5.88457 5.86292 5.7247 5.91621 5.60628 6.02377C5.48794 6.13163 5.39897 6.2678 5.34773 6.4195L4.66977 6.13726C4.75957 5.88266 4.92438 5.65766 5.16615 5.46325C5.40793 5.26884 5.71681 5.17114 6.09181 5.17114C6.36911 5.17114 6.61878 5.22443 6.83984 5.332C7.06089 5.43956 7.23457 5.58858 7.3599 5.77805C7.48523 5.96851 7.5474 6.18167 7.5474 6.41851C7.5474 6.66029 7.48918 6.86456 7.37273 7.03233C7.25628 7.20009 7.11319 7.32838 6.94345 7.41818V7.45864C7.16262 7.549 7.35301 7.69742 7.49411 7.88792C7.6372 8.08035 7.70924 8.31029 7.70924 8.57871C7.70924 8.84713 7.64115 9.08693 7.50497 9.29713C7.36878 9.50733 7.1803 9.67312 6.94148 9.79351C6.70168 9.91391 6.43227 9.97509 6.13326 9.97509C5.78688 9.97608 5.46714 9.87641 5.17207 9.67706V9.67706ZM9.37898 6.27838L8.62701 6.82213L8.25102 6.25174L9.60003 5.27871H10.1171V9.86851H9.37898V6.27838Z"
      fill="#4285F4"
    />
  </svg>
);

export const GoogleSheets = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_527_6312"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="11"
      height="15"
    >
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_527_6312)">
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L10.4804 2.53264L8.82461 0.214539Z"
        fill="#0F9D58"
      />
    </g>
    <mask
      id="mask1_527_6312"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="11"
      height="15"
    >
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_527_6312)">
      <path
        d="M4.85074 7.33441V12.1362H10.1492V7.33441H4.85074ZM7.16884 11.4739H5.51305V10.646H7.16884V11.4739ZM7.16884 10.1492H5.51305V9.32135H7.16884V10.1492ZM7.16884 8.82462H5.51305V7.99673H7.16884V8.82462ZM9.48693 11.4739H7.83115V10.646H9.48693V11.4739ZM9.48693 10.1492H7.83115V9.32135H9.48693V10.1492ZM9.48693 8.82462H7.83115V7.99673H9.48693V8.82462Z"
        fill="#F1F1F1"
      />
    </g>
    <mask
      id="mask2_527_6312"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="11"
      height="15"
    >
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_527_6312)">
      <path
        d="M9.1152 3.89783L12.7985 7.58029V4.18842L9.1152 3.89783Z"
        fill="url(#paint0_linear_527_6312)"
      />
    </g>
    <mask
      id="mask3_527_6312"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="11"
      height="15"
    >
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_527_6312)">
      <path
        d="M8.82462 0.214539V3.19495C8.82462 3.74384 9.26919 4.18842 9.81809 4.18842H12.7985L8.82462 0.214539Z"
        fill="#87CEAC"
      />
    </g>
    <mask
      id="mask4_527_6312"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="11"
      height="15"
    >
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_527_6312)">
      <path
        d="M3.19495 0.214539C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V1.2908C2.20148 0.744389 2.64854 0.297328 3.19495 0.297328H8.82461V0.214539H3.19495Z"
        fill="white"
        fillOpacity="0.2"
      />
    </g>
    <mask
      id="mask5_527_6312"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="11"
      height="15"
    >
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_527_6312)">
      <path
        d="M11.805 14.7026H3.19495C2.64854 14.7026 2.20148 14.2556 2.20148 13.7092V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V13.7092C12.7985 14.2556 12.3514 14.7026 11.805 14.7026Z"
        fill="#263238"
        fillOpacity="0.2"
      />
    </g>
    <mask
      id="mask6_527_6312"
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="11"
      height="15"
    >
      <path
        d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_527_6312)">
      <path
        d="M9.81809 4.18842C9.26919 4.18842 8.82462 3.74384 8.82462 3.19495V3.27774C8.82462 3.82663 9.26919 4.27121 9.81809 4.27121H12.7985V4.18842H9.81809Z"
        fill="#263238"
        fillOpacity="0.1"
      />
    </g>
    <path
      d="M8.82461 0.214539H3.19495C2.64854 0.214539 2.20148 0.6616 2.20148 1.20801V13.792C2.20148 14.3384 2.64854 14.7854 3.19495 14.7854H11.805C12.3514 14.7854 12.7985 14.3384 12.7985 13.792V4.18842L8.82461 0.214539Z"
      fill="url(#paint1_radial_527_6312)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_527_6312"
        x1="10.957"
        y1="4.21401"
        x2="10.957"
        y2="7.5808"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#263238" stopOpacity="0.2" />
        <stop offset="1" stopColor="#263238" stopOpacity="0.02" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_527_6312"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(2.5372 0.504165) scale(17.0875)"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const DownArrow = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.25 5.625L8 9.375L11.75 5.625"
      stroke="#F7F7F8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownArrowSmall = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.71428 5.07141L6.71428 8.07141L9.71428 5.07141"
      stroke={COLORS.darkGray}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TwitterIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9569 2.9214C14.4066 3.16549 13.8151 3.33039 13.1945 3.40458C13.828 3.02482 14.3146 2.42348 14.5437 1.7069C13.9507 2.05861 13.294 2.31392 12.595 2.45153C12.0353 1.85512 11.2378 1.48254 10.3552 1.48254C8.66061 1.48254 7.2866 2.85641 7.2866 4.55102C7.2866 4.79153 7.31375 5.02576 7.3661 5.25034C4.8158 5.12238 2.55476 3.9007 1.04127 2.04417C0.777135 2.49737 0.625771 3.02445 0.625771 3.58683C0.625771 4.65146 1.16751 5.59068 1.99089 6.14094C1.48789 6.12501 1.01472 5.98696 0.601017 5.75715C0.600668 5.76994 0.600668 5.7828 0.600668 5.79574C0.600668 7.28245 1.65842 8.5226 3.0622 8.80469C2.80472 8.87484 2.53362 8.9123 2.25378 8.9123C2.05605 8.9123 1.86386 8.89301 1.67644 8.85726C2.06697 10.0763 3.20018 10.9635 4.54301 10.9882C3.49281 11.8112 2.16972 12.3018 0.731991 12.3018C0.484304 12.3018 0.240058 12.2873 0 12.2589C1.35801 13.1296 2.97096 13.6376 4.70387 13.6376C10.3481 13.6376 13.4347 8.96189 13.4347 4.90677C13.4347 4.77373 13.4317 4.64144 13.4258 4.50974C14.0252 4.07719 14.5454 3.5368 14.9568 2.9214H14.9569Z"
      fill="#2AA9E0"
    />
  </svg>
);

export const TwitterIconLarge = () => (
  <svg
    style={{ marginTop: 2 }}
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9281 4.86903C24.011 5.27586 23.0252 5.55069 21.9908 5.67434C23.0467 5.04141 23.8577 4.03918 24.2395 2.84487C23.2512 3.43106 22.1567 3.85658 20.9917 4.08592C20.0589 3.09191 18.7297 2.47095 17.2587 2.47095C14.4344 2.47095 12.1443 4.76072 12.1443 7.58508C12.1443 7.98592 12.1896 8.3763 12.2768 8.7506C8.02633 8.53734 4.25794 6.5012 1.73546 3.407C1.29523 4.16232 1.04295 5.04079 1.04295 5.97809C1.04295 7.75248 1.94585 9.31784 3.31814 10.2349C2.47981 10.2084 1.69121 9.97831 1.0017 9.59529C1.00111 9.6166 1.00111 9.63804 1.00111 9.6596C1.00111 12.1375 2.76403 14.2044 5.10367 14.6745C4.67453 14.7914 4.2227 14.8539 3.7563 14.8539C3.42675 14.8539 3.10643 14.8217 2.79407 14.7621C3.44495 16.7939 5.33363 18.2725 7.57168 18.3137C5.82135 19.6855 3.6162 20.5031 1.21998 20.5031C0.807173 20.5031 0.400097 20.4788 0 20.4316C2.26335 21.8827 4.9516 22.7294 7.83978 22.7294C17.2468 22.7294 22.3911 14.9365 22.3911 8.178C22.3911 7.95626 22.3861 7.73577 22.3763 7.51628C23.3754 6.79536 24.2424 5.8947 24.928 4.86903H24.9281Z"
      fill="#2AA9E0"
    />
  </svg>
);

export const GoogleDriveIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_535_6315)">
      <path
        d="M1.13793 12.3879L1.80172 13.5345C1.93966 13.7759 2.13793 13.9655 2.37069 14.1034L4.74138 10H0C0 10.2672 0.0689655 10.5345 0.206897 10.7759L1.13793 12.3879Z"
        fill="#0066DA"
      />
      <path
        d="M7.52586 5.17242L5.15517 1.06897C4.92241 1.2069 4.72414 1.39656 4.5862 1.63794L0.206896 9.22414C0.0715022 9.46032 0.000180269 9.72777 0 10H4.74138L7.52586 5.17242Z"
        fill="#00AC47"
      />
      <path
        d="M12.681 14.1034C12.9138 13.9655 13.1121 13.7759 13.25 13.5345L13.5259 13.0603L14.8448 10.7759C14.9828 10.5345 15.0517 10.2672 15.0517 10H10.31L11.319 11.9828L12.681 14.1034Z"
        fill="#EA4335"
      />
      <path
        d="M7.52584 5.17241L9.89653 1.06896C9.66377 0.931026 9.39653 0.862061 9.12067 0.862061H5.93101C5.65515 0.862061 5.38791 0.939647 5.15515 1.06896L7.52584 5.17241Z"
        fill="#00832D"
      />
      <path
        d="M10.3103 10H4.74136L2.37067 14.1034C2.60343 14.2414 2.87067 14.3103 3.14653 14.3103H11.9052C12.181 14.3103 12.4483 14.2328 12.681 14.1034L10.3103 10Z"
        fill="#2684FC"
      />
      <path
        d="M12.6552 5.43104L10.4655 1.63794C10.3276 1.39656 10.1293 1.2069 9.89657 1.06897L7.52588 5.17242L10.3104 10H15.0431C15.0431 9.73276 14.9742 9.46552 14.8362 9.22414L12.6552 5.43104Z"
        fill="#FFBA00"
      />
    </g>
    <defs>
      <clipPath id="clip0_535_6315">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GoogleIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.64 9.20456C17.64 8.56637 17.5827 7.95274 17.4764 7.36365H9V10.845H13.8436C13.635 11.97 13.0009 12.9232 12.0477 13.5614V15.8196H14.9564C16.6582 14.2527 17.64 11.9455 17.64 9.20456Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.96409 10.7099C3.78409 10.1699 3.68182 9.59313 3.68182 8.99995C3.68182 8.40677 3.78409 7.82995 3.96409 7.28995V4.95813H0.957273C0.347727 6.17313 0 7.54768 0 8.99995C0 10.4522 0.347727 11.8268 0.957273 13.0418L3.96409 10.7099Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
      fill="#EA4335"
    />
  </svg>
);

export const SpeakerIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0215 3.3465C12.8025 2.9835 12.3825 2.8245 12.0015 2.958L6.33899 4.9455V8.7675L12.0015 10.752C12.0915 10.7835 12.1845 10.7985 12.276 10.7985C12.5715 10.7985 12.855 10.6395 13.0215 10.3635C13.9695 8.79 13.9695 4.9215 13.0215 3.3465Z"
      fill="#8D8D8D"
    />
    <path
      d="M5.96099 4.968H2.84699C1.97549 4.968 1.26749 5.7195 1.26749 6.642V7.0725C1.26749 7.995 1.97549 8.74651 2.84699 8.74651H3.39899L4.27649 11.622C4.32749 11.79 4.44149 11.928 4.59749 12.0105C4.69349 12.0615 4.79849 12.0885 4.90499 12.0885C4.96949 12.0885 5.03549 12.0795 5.09849 12.0585L5.29949 11.997C5.46749 11.946 5.60549 11.8335 5.68799 11.6775C5.77049 11.5215 5.78849 11.343 5.73599 11.1735L4.99499 8.745H5.95949V4.968H5.96099Z"
      fill="#8D8D8D"
    />
  </svg>
);

export const GoogleMailIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5625 12.6562H3.75V7.34375L0.625 5V11.7188C0.625 12.2375 1.04531 12.6562 1.5625 12.6562Z"
      fill="#4285F4"
    />
    <path
      d="M11.25 12.6562H13.4375C13.9562 12.6562 14.375 12.2359 14.375 11.7188V5L11.25 7.34375"
      fill="#34A853"
    />
    <path
      d="M11.25 3.28125V7.34375L14.375 5V3.75C14.375 2.59063 13.0516 1.92969 12.125 2.625"
      fill="#FBBC04"
    />
    <path
      d="M3.75 7.34375V3.28125L7.5 6.09375L11.25 3.28125V7.34375L7.5 10.1562"
      fill="#EA4335"
    />
    <path
      d="M0.625 3.75V5L3.75 7.34375V3.28125L2.875 2.625C1.94688 1.92969 0.625 2.59063 0.625 3.75"
      fill="#C5221F"
    />
  </svg>
);

export const CopyToClipboardIcon = () => (
  <svg
    style={{ marginRight: 8 }}
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 5.625H6.875C6.18464 5.625 5.625 6.18464 5.625 6.875V12.5C5.625 13.1904 6.18464 13.75 6.875 13.75H12.5C13.1904 13.75 13.75 13.1904 13.75 12.5V6.875C13.75 6.18464 13.1904 5.625 12.5 5.625Z"
      stroke="#F7F7F8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.125 9.375H2.5C2.16848 9.375 1.85054 9.2433 1.61612 9.00888C1.3817 8.77446 1.25 8.45652 1.25 8.125V2.5C1.25 2.16848 1.3817 1.85054 1.61612 1.61612C1.85054 1.3817 2.16848 1.25 2.5 1.25H8.125C8.45652 1.25 8.77446 1.3817 9.00888 1.61612C9.2433 1.85054 9.375 2.16848 9.375 2.5V3.125"
      stroke="#F7F7F8"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SpotifyIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_551_6312)">
      <path
        d="M7.48887 0C3.35297 0 0 3.35784 0 7.49986C0 11.6423 3.35297 15 7.48887 15C11.625 15 14.9777 11.6423 14.9777 7.49986C14.9777 3.35811 11.6251 0.000357962 7.48878 0.000357962L7.48887 0ZM10.9232 10.817C10.7887 11.0379 10.5013 11.1071 10.2814 10.9725C8.52282 9.8961 6.30932 9.65295 3.70253 10.2493C3.45133 10.307 3.20094 10.1493 3.14371 9.8978C3.08621 9.64624 3.24297 9.39547 3.4948 9.33816C6.34751 8.685 8.7945 8.96613 10.7684 10.1741C10.9884 10.3093 11.0582 10.5968 10.9231 10.8171L10.9232 10.817ZM11.8398 8.7751C11.6705 9.05031 11.3111 9.13665 11.0367 8.96765C9.02415 7.72869 5.95528 7.36982 3.5743 8.09364C3.26551 8.18705 2.93937 8.01277 2.84565 7.70406C2.75264 7.39481 2.92676 7.06881 3.23501 6.97478C5.95475 6.14833 9.3358 6.54865 11.6475 7.97131C11.922 8.14057 12.0088 8.5006 11.8397 8.77519L11.8398 8.7751ZM11.9185 6.6486C9.50454 5.21288 5.52272 5.08087 3.21828 5.78131C2.84824 5.8937 2.45691 5.68449 2.34476 5.3139C2.23262 4.94313 2.44135 4.55148 2.81166 4.43882C5.457 3.63458 9.85457 3.78996 12.6334 5.44206C12.9663 5.63989 13.0755 6.0704 12.8782 6.4033C12.6814 6.73664 12.2504 6.84652 11.9186 6.6486H11.9185ZM20.3747 6.92373C19.0817 6.61493 18.8515 6.3982 18.8515 5.94278C18.8515 5.51255 19.256 5.223 19.8575 5.223C20.4406 5.223 21.0187 5.44287 21.6248 5.8955C21.6432 5.90921 21.6662 5.91466 21.6888 5.91108C21.7114 5.90768 21.7314 5.89523 21.7447 5.87651L22.376 4.98522C22.402 4.9485 22.3949 4.8979 22.3599 4.86987C21.6385 4.29015 20.8262 4.00831 19.8766 4.00831C18.4805 4.00831 17.5053 4.84739 17.5053 6.04793C17.5053 7.33534 18.3465 7.7912 19.8003 8.14308C21.0376 8.4285 21.2464 8.66763 21.2464 9.09509C21.2464 9.56877 20.8241 9.86324 20.1446 9.86324C19.3898 9.86324 18.7742 9.60863 18.0855 9.01135C18.0684 8.99657 18.045 8.98986 18.0234 8.99112C18.0006 8.99299 17.9797 9.00356 17.9652 9.02103L17.2573 9.86476C17.2276 9.89978 17.2314 9.95208 17.2657 9.98236C18.067 10.6987 19.0525 11.0771 20.1159 11.0771C21.6204 11.0771 22.5925 10.2539 22.5925 8.97975C22.5952 7.90414 21.9522 7.30857 20.3774 6.9249L20.3747 6.92373ZM25.9961 5.64661C25.344 5.64661 24.8091 5.90383 24.3681 6.43088V5.83764C24.3681 5.7908 24.3302 5.75265 24.2835 5.75265H23.1257C23.0789 5.75265 23.0411 5.7908 23.0411 5.83764V12.4294C23.0411 12.4762 23.0789 12.5144 23.1257 12.5144H24.2835C24.3302 12.5144 24.3681 12.4762 24.3681 12.4294V10.3486C24.8092 10.8444 25.3442 11.0867 25.9961 11.0867C27.2078 11.0867 28.4343 10.1526 28.4343 8.36698C28.4361 6.5809 27.2092 5.64653 25.9975 5.64653L25.9961 5.64661ZM27.088 8.36698C27.088 9.27627 26.5287 9.9108 25.7279 9.9108C24.9362 9.9108 24.339 9.24743 24.339 8.36698C24.339 7.48661 24.9362 6.82316 25.7279 6.82316C26.5158 6.82306 27.0881 7.47219 27.0881 8.36688L27.088 8.36698ZM31.5781 5.64661C30.0177 5.64661 28.7953 6.84993 28.7953 8.38641C28.7953 9.90614 30.0093 11.0968 31.559 11.0968C33.125 11.0968 34.3512 9.89754 34.3512 8.36697C34.3512 6.84169 33.1332 5.64679 31.578 5.64679L31.5781 5.64661ZM31.5781 9.91984C30.7482 9.91984 30.1224 9.252 30.1224 8.36652C30.1224 7.47729 30.7265 6.83201 31.559 6.83201C32.3943 6.83201 33.0243 7.49986 33.0243 8.38596C33.0243 9.27501 32.4162 9.91984 31.5782 9.91984H31.5781ZM37.6833 5.75266H36.4092V4.44813C36.4092 4.40138 36.3715 4.36323 36.3247 4.36323H35.1671C35.1202 4.36323 35.0822 4.40138 35.0822 4.44813V5.75266H34.5255C34.479 5.75266 34.4412 5.7908 34.4412 5.83764V6.83417C34.4412 6.88092 34.479 6.91916 34.5255 6.91916H35.0822V9.49766C35.0822 10.5397 35.6001 11.068 36.6214 11.068C37.0368 11.068 37.3813 10.9821 37.706 10.7977C37.7324 10.7829 37.7488 10.7544 37.7488 10.7242V9.77521C37.7488 9.74592 37.7336 9.71825 37.7085 9.70293C37.6833 9.68708 37.6519 9.68628 37.6261 9.69908C37.403 9.81148 37.1874 9.86333 36.9464 9.86333C36.5749 9.86333 36.4092 9.69442 36.4092 9.31586V6.91961H37.6833C37.7301 6.91961 37.7677 6.88146 37.7677 6.83462V5.83819C37.7695 5.79135 37.7319 5.7532 37.6846 5.7532L37.6833 5.75266ZM42.1225 5.75776V5.59753C42.1225 5.12618 42.3029 4.91599 42.7077 4.91599C42.949 4.91599 43.1429 4.96399 43.36 5.03653C43.3868 5.04496 43.4147 5.04075 43.4364 5.02471C43.4588 5.00868 43.4714 4.98298 43.4714 4.95575V3.97866C43.4714 3.94131 43.4474 3.90827 43.4115 3.89725C43.1821 3.82891 42.8886 3.75879 42.4491 3.75879C41.3798 3.75879 40.8145 4.36188 40.8145 5.50224V5.74763H40.2583C40.2116 5.74763 40.1733 5.78578 40.1733 5.83253V6.83416C40.1733 6.88091 40.2116 6.91915 40.2583 6.91915H40.8145V10.8964C40.8145 10.9432 40.8522 10.9814 40.8989 10.9814H42.0567C42.1035 10.9814 42.1416 10.9432 42.1416 10.8964V6.91943H43.2226L44.8785 10.8957C44.6905 11.3135 44.5057 11.3966 44.2533 11.3966C44.0493 11.3966 43.8345 11.3356 43.6149 11.2152C43.5942 11.2038 43.5697 11.202 43.5475 11.2089C43.5254 11.2167 43.5068 11.2331 43.4974 11.2546L43.105 12.1168C43.0863 12.1576 43.1023 12.2054 43.1415 12.2265C43.5511 12.4487 43.9209 12.5436 44.378 12.5436C45.2329 12.5436 45.7054 12.1448 46.122 11.0718L48.1306 5.87382C48.1407 5.84767 48.1377 5.81812 48.1217 5.79492C48.1058 5.7719 48.0801 5.75802 48.052 5.75802H46.8467C46.8106 5.75802 46.7783 5.78104 46.7665 5.81498L45.5318 9.34702L44.1794 5.81266C44.167 5.77979 44.1354 5.75802 44.1003 5.75802H42.1222L42.1225 5.75776ZM39.5487 5.75266H38.3909C38.3442 5.75266 38.3061 5.7908 38.3061 5.83764V10.8964C38.3061 10.9432 38.3442 10.9814 38.3909 10.9814H39.5487C39.5954 10.9814 39.6336 10.9432 39.6336 10.8964V5.838C39.6336 5.82682 39.6315 5.81575 39.6272 5.80542C39.6229 5.79509 39.6167 5.78571 39.6088 5.77781C39.6009 5.76991 39.5915 5.76366 39.5812 5.7594C39.5709 5.75514 39.5598 5.75297 39.5486 5.75301L39.5487 5.75266ZM38.9764 3.44928C38.5177 3.44928 38.1455 3.82113 38.1455 4.28048C38.1455 4.7401 38.5178 5.1124 38.9764 5.1124C39.4349 5.1124 39.8067 4.7401 39.8067 4.28048C39.8067 3.82122 39.4347 3.44928 38.9769 3.44928H38.9764ZM49.1192 7.37914C48.661 7.37914 48.3044 7.0106 48.3044 6.56307C48.3044 6.11554 48.6656 5.7428 49.1235 5.7428C49.5817 5.7428 49.9383 6.11125 49.9383 6.55841C49.9383 7.00594 49.577 7.37914 49.1191 7.37914H49.1192ZM49.1237 5.82394C48.7063 5.82394 48.3906 6.1562 48.3906 6.56307C48.3906 6.96976 48.7041 7.29755 49.1195 7.29755C49.5367 7.29755 49.8529 6.96556 49.8529 6.55841C49.8529 6.15173 49.539 5.82394 49.124 5.82394H49.1237ZM49.3043 6.64233L49.5348 6.96546H49.3405L49.133 6.66902H48.9546V6.96546H48.7919V6.10892H49.1733C49.372 6.10892 49.5027 6.21074 49.5027 6.38217C49.5036 6.5226 49.4222 6.60839 49.3051 6.64233L49.3043 6.64233ZM49.1666 6.25589H48.9545V6.52681H49.1666C49.2725 6.52681 49.3357 6.47495 49.3357 6.39121C49.3357 6.30309 49.2722 6.25589 49.1667 6.25589L49.1666 6.25589Z"
        fill="#2EBD59"
      />
    </g>
    <defs>
      <clipPath id="clip0_551_6312">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ZoomIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z"
      fill="#2196F3"
    />
    <path
      d="M9.375 10.125H3.75C3.12863 10.125 2.625 9.62137 2.625 9V4.875H8.25C8.87137 4.875 9.375 5.37863 9.375 6V10.125Z"
      fill="white"
    />
    <path
      d="M12.375 10.125L10.125 8.625V6.375L12.375 4.875V10.125Z"
      fill="white"
    />
  </svg>
);

export const NetlifyIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_557_6312)">
      <path
        d="M10.8326 5.30063L10.8274 5.29838C10.8244 5.29725 10.8214 5.29613 10.8187 5.2935C10.8144 5.28888 10.8113 5.28333 10.8094 5.27729C10.8076 5.27124 10.8072 5.26486 10.8082 5.25863L11.0981 3.48638L12.4575 4.84613L11.0437 5.44763C11.0398 5.44921 11.0356 5.44998 11.0314 5.44988H11.0257C11.0239 5.44875 11.022 5.44725 11.0182 5.4435C10.9656 5.38492 10.9027 5.33649 10.8326 5.30063V5.30063ZM12.8044 5.19263L14.2579 6.64613C14.5597 6.94838 14.7109 7.09913 14.766 7.27388C14.7742 7.29975 14.781 7.32563 14.7862 7.35225L11.3126 5.88113C11.3108 5.88036 11.3089 5.87961 11.307 5.87888C11.2931 5.87325 11.277 5.86688 11.277 5.85263C11.277 5.83838 11.2935 5.83163 11.3074 5.826L11.3119 5.82413L12.8044 5.19263ZM14.727 7.81875C14.652 7.95975 14.5057 8.106 14.2582 8.35388L12.6195 9.99225L10.5 9.55088L10.4887 9.54863C10.47 9.54563 10.4501 9.54225 10.4501 9.52538C10.4421 9.43794 10.4161 9.3531 10.3739 9.27614C10.3316 9.19917 10.2739 9.13173 10.2045 9.078C10.1959 9.06938 10.1981 9.05588 10.2007 9.0435C10.2007 9.04163 10.2007 9.03975 10.2015 9.03825L10.6001 6.591L10.6016 6.58275C10.6039 6.564 10.6072 6.54225 10.6241 6.54225C10.7095 6.53163 10.792 6.5041 10.8667 6.46129C10.9414 6.41848 11.0068 6.36123 11.0591 6.29288C11.0625 6.28913 11.0647 6.285 11.0692 6.28275C11.0812 6.27713 11.0955 6.28275 11.1079 6.288L14.7266 7.81875H14.727ZM12.2426 10.3691L9.54787 13.0639L10.0091 10.2289L10.0099 10.2251C10.0102 10.2214 10.011 10.2176 10.0121 10.2143C10.0159 10.2053 10.0256 10.2015 10.035 10.1978L10.0395 10.1959C10.1405 10.1528 10.2298 10.0863 10.3001 10.002C10.3091 9.9915 10.32 9.98138 10.3339 9.9795C10.3375 9.97891 10.3411 9.97891 10.3447 9.9795L12.2422 10.3695L12.2426 10.3691ZM8.9775 13.6343L8.67375 13.938L5.31562 9.08475C5.31441 9.08298 5.31316 9.08123 5.31187 9.0795C5.30662 9.07238 5.301 9.06525 5.30212 9.057C5.30212 9.051 5.30625 9.04575 5.31037 9.04125L5.31412 9.03638C5.32425 9.02138 5.33287 9.00638 5.34225 8.99025L5.34975 8.97713L5.35087 8.976C5.35612 8.967 5.361 8.95838 5.37 8.9535C5.37787 8.94975 5.38875 8.95125 5.39737 8.95313L9.11775 9.72038C9.12815 9.722 9.13796 9.72626 9.14625 9.73275C9.15112 9.73763 9.15225 9.74288 9.15337 9.74888C9.17932 9.84707 9.22762 9.93792 9.29449 10.0144C9.36136 10.0908 9.445 10.1507 9.53887 10.1895C9.54937 10.1948 9.54487 10.2064 9.54 10.2188C9.53756 10.2242 9.53568 10.2298 9.53437 10.2356C9.4875 10.5206 9.0855 12.9724 8.9775 13.6343ZM8.343 14.2684C8.11912 14.49 7.98712 14.6074 7.83787 14.6546C7.69071 14.7012 7.53278 14.7012 7.38562 14.6546C7.21087 14.5991 7.05975 14.4484 6.75787 14.1461L3.3855 10.7738L4.26637 9.40763C4.2705 9.40088 4.27462 9.39488 4.28137 9.39C4.29075 9.38325 4.30425 9.38625 4.3155 9.39C4.51768 9.451 4.73476 9.44 4.92975 9.35888C4.93987 9.35513 4.95 9.3525 4.95787 9.35963C4.96181 9.36322 4.96533 9.36725 4.96837 9.37163L8.343 14.2688V14.2684ZM3.06037 10.4486L2.28675 9.675L3.8145 9.02325C3.8184 9.02155 3.82261 9.02066 3.82687 9.02063C3.83962 9.02063 3.84712 9.03338 3.85387 9.045C3.86922 9.06862 3.88549 9.09164 3.90262 9.114L3.9075 9.12C3.912 9.12638 3.909 9.13275 3.9045 9.13875L3.06075 10.4486H3.06037ZM1.94437 9.33263L0.96562 8.35388C0.79912 8.18738 0.67837 8.06663 0.59437 7.96275L3.57037 8.58C3.57411 8.5807 3.57786 8.58132 3.58162 8.58188C3.6 8.58488 3.62025 8.58825 3.62025 8.6055C3.62025 8.62425 3.59812 8.63288 3.57937 8.64L3.57075 8.64375L1.94437 9.33263ZM0.42337 7.4595C0.426762 7.39645 0.438102 7.33409 0.45712 7.27388C0.51262 7.09913 0.66337 6.94838 0.96562 6.64613L2.21812 5.39363C2.79481 6.23058 3.37306 7.06646 3.95287 7.90125C3.963 7.91475 3.97425 7.92975 3.96262 7.941C3.90787 8.00138 3.85312 8.06738 3.8145 8.139C3.8103 8.14821 3.80386 8.15621 3.79575 8.16225C3.79087 8.16525 3.78562 8.16413 3.78 8.163H3.77925L0.42337 7.45913V7.4595ZM2.55337 5.05838L4.23675 3.37425C4.39537 3.44363 4.97175 3.687 5.48662 3.9045C5.87662 4.0695 6.23212 4.2195 6.34387 4.26825C6.35512 4.27275 6.36524 4.27725 6.37012 4.2885C6.37312 4.29525 6.37162 4.30388 6.37012 4.311C6.34346 4.43257 6.34743 4.55885 6.38166 4.67851C6.41589 4.79816 6.47932 4.90743 6.56625 4.9965C6.5775 5.00775 6.56625 5.02388 6.5565 5.03775L6.55125 5.04563L4.84125 7.69425C4.83675 7.70175 4.83262 7.70813 4.82512 7.713C4.81612 7.71863 4.80337 7.716 4.79287 7.71338C4.72636 7.69595 4.65799 7.68664 4.58925 7.68563C4.52775 7.68563 4.461 7.69688 4.3935 7.70925H4.39312C4.38562 7.71038 4.37887 7.71188 4.37287 7.70738C4.36624 7.70196 4.36054 7.6955 4.356 7.68825L2.553 5.05838H2.55337ZM4.57762 3.03413L6.75787 0.853877C7.05975 0.552002 7.21087 0.400877 7.38562 0.345752C7.53278 0.299219 7.69071 0.299219 7.83787 0.345752C8.01262 0.400877 8.16375 0.552002 8.46562 0.853877L8.93812 1.32638L7.3875 3.72788C7.38366 3.73487 7.37843 3.741 7.37212 3.74588C7.36275 3.75225 7.34962 3.74963 7.33837 3.74588C7.21612 3.70878 7.08666 3.70202 6.96121 3.7262C6.83576 3.75037 6.71808 3.80475 6.61837 3.88463C6.60825 3.89513 6.59325 3.88913 6.5805 3.8835C6.378 3.79538 4.803 3.12975 4.57762 3.03413V3.03413ZM9.26737 1.65563L10.6991 3.08738L10.3541 5.22413V5.22975C10.3538 5.23462 10.3528 5.23942 10.3511 5.244C10.3474 5.2515 10.3399 5.253 10.3324 5.25525C10.2586 5.2776 10.1891 5.3122 10.1269 5.35763C10.1242 5.35953 10.1217 5.36167 10.1194 5.364C10.1152 5.3685 10.1111 5.37263 10.1044 5.37338C10.0989 5.37355 10.0934 5.37266 10.0882 5.37075L7.9065 4.44375L7.90237 4.44188C7.8885 4.43625 7.872 4.4295 7.872 4.41525C7.85917 4.29367 7.81946 4.17647 7.75575 4.07213C7.74525 4.05488 7.73362 4.03688 7.74262 4.01925L9.26737 1.65563ZM7.79287 4.88288L9.83812 5.74913C9.84937 5.75438 9.86175 5.75925 9.86662 5.77088C9.86857 5.77787 9.86857 5.78526 9.86662 5.79225C9.86062 5.82225 9.85537 5.85638 9.85537 5.89088V5.94825C9.85537 5.9625 9.84075 5.9685 9.82725 5.97413L9.82312 5.97563C9.49912 6.114 5.27437 7.9155 5.268 7.9155C5.26162 7.9155 5.25487 7.9155 5.2485 7.90913C5.23725 7.89788 5.2485 7.88213 5.25862 7.86788C5.26041 7.86541 5.26216 7.86291 5.26387 7.86038L6.94462 5.25788L6.94762 5.25338C6.95737 5.23763 6.96862 5.22 6.98662 5.22L7.0035 5.22263C7.04175 5.22788 7.0755 5.23275 7.10962 5.23275C7.36462 5.23275 7.60087 5.10863 7.74337 4.89638C7.74677 4.89071 7.75107 4.88564 7.75612 4.88138C7.76625 4.87388 7.78125 4.87763 7.79287 4.88288V4.88288ZM5.45062 8.32725L10.0556 6.36338C10.0556 6.36338 10.0624 6.36338 10.0687 6.36975C10.0939 6.39488 10.1152 6.41175 10.1359 6.4275L10.146 6.43388C10.1554 6.43913 10.1647 6.44513 10.1655 6.45488C10.1655 6.45863 10.1655 6.46088 10.1647 6.46425L9.77025 8.8875L9.76875 8.89725C9.76612 8.916 9.7635 8.93738 9.74587 8.93738C9.64069 8.94448 9.53884 8.97711 9.44912 9.03246C9.3594 9.08781 9.28453 9.16419 9.231 9.255L9.22912 9.258C9.22387 9.26663 9.219 9.27488 9.21037 9.27938C9.2025 9.28313 9.19237 9.28163 9.18412 9.27975L5.51175 8.52225C5.508 8.5215 5.45475 8.32763 5.45062 8.32725V8.32725Z"
        fill="url(#paint0_radial_557_6312)"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_557_6312"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-0.0588529 7.29732) rotate(90) scale(14.3629 16.5825)"
      >
        <stop stopColor="#20C6B7" />
        <stop offset="1" stopColor="#4D9ABF" />
      </radialGradient>
      <clipPath id="clip0_557_6312">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OktaIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_560_6315)">
      <path
        d="M7.4703 -0.0297031C3.34158 -0.0297031 0 3.31188 0 7.44059C0 11.5693 3.34158 14.9109 7.4703 14.9109C11.599 14.9109 14.9406 11.5693 14.9406 7.44059C14.9406 3.31188 11.599 -0.0297031 7.4703 -0.0297031ZM7.4703 11.1832C5.40594 11.1832 3.72772 9.50495 3.72772 7.44059C3.72772 5.37624 5.40594 3.69802 7.4703 3.69802C9.53465 3.69802 11.2129 5.37624 11.2129 7.44059C11.2129 9.50495 9.53465 11.1832 7.4703 11.1832Z"
        fill="#007DC1"
      />
    </g>
    <defs>
      <clipPath id="clip0_560_6315">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GoogleMapsIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_562_6312)">
      <path
        d="M9.11363 0.25C8.61363 0.0909091 8.06818 0 7.51136 0C5.90909 0 4.46591 0.727273 3.5 1.875L5.97727 3.95455L9.11363 0.25Z"
        fill="#1A73E8"
      />
      <path
        d="M3.5 1.875C2.73864 2.78409 2.27273 3.96591 2.27273 5.23864C2.27273 6.22727 2.46591 7.02273 2.79546 7.73864L5.97727 3.95455L3.5 1.875V1.875Z"
        fill="#EA4335"
      />
      <path
        d="M7.52273 3.23864C8.63636 3.23864 9.53409 4.13636 9.53409 5.25C9.53409 5.73864 9.35227 6.19318 9.05682 6.54545C9.05682 6.54545 10.6364 4.65909 12.1818 2.82955C11.5455 1.60227 10.4432 0.670455 9.11364 0.25L5.97727 3.95455C6.35227 3.52273 6.89773 3.23864 7.52273 3.23864"
        fill="#4285F4"
      />
      <path
        d="M7.52273 7.25C6.40909 7.25 5.51136 6.35227 5.51136 5.23863C5.51136 4.75 5.68182 4.29545 5.97727 3.95454L2.79546 7.73863C3.34091 8.94318 4.25 9.92045 5.18182 11.1364L9.05682 6.53409C8.68182 6.97727 8.13636 7.25 7.52273 7.25Z"
        fill="#FBBC04"
      />
      <path
        d="M8.98864 12.4091C10.7386 9.67045 12.7727 8.43182 12.7727 5.25C12.7727 4.375 12.5568 3.55682 12.1818 2.82954L5.18182 11.1364C5.47727 11.5227 5.78409 11.9659 6.07955 12.4205C7.14773 14.0682 6.85227 15.0455 7.53409 15.0455C8.21591 15.0455 7.92045 14.0568 8.98864 12.4091"
        fill="#34A853"
      />
    </g>
    <defs>
      <clipPath id="clip0_562_6312">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SmallDarkGrayLock = () => (
  <svg
    style={{ marginRight: 6 }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_603_6312)">
      <path
        d="M11.9276 7.61188H3.17761C2.48726 7.61188 1.92761 8.17152 1.92761 8.86188V13.2369C1.92761 13.9272 2.48726 14.4869 3.17761 14.4869H11.9276C12.618 14.4869 13.1776 13.9272 13.1776 13.2369V8.86188C13.1776 8.17152 12.618 7.61188 11.9276 7.61188Z"
        stroke="#8D8D8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.42761 7.61188V5.11188C4.42761 4.28308 4.75685 3.48822 5.3429 2.90217C5.92895 2.31612 6.72381 1.98688 7.55261 1.98688C8.38141 1.98688 9.17627 2.31612 9.76232 2.90217C10.3484 3.48822 10.6776 4.28308 10.6776 5.11188V7.61188"
        stroke="#8D8D8D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_603_6312">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0.0526123 0.736877)"
        />
      </clipPath>
    </defs>
  </svg>
);
